import { ucFirst } from "./StringHelper";

/*
 * Label + billing-badge tone for a site's Status column. Mirrors the
 * customer console's status pill (customer/src/console/Sites.jsx +
 * helpers/SiteStatusHelper.js): billing state overrides the operational
 * status because a suspended site is disabled regardless of what Ansible
 * last did, and a site awaiting/failed payment was never actually
 * provisioned in the first place.
 */
const STATUS_LABEL_TONE = {
  idle: ["Live", "ok"],
  active: ["Live", "ok"],
  pending: ["Pending", "warn"],
  creating: ["Creating", "warn"],
  migrating: ["Migrating", "warn"],
  updating: ["Updating", "warn"],
  restoring: ["Restoring", "warn"],
  deleting: ["Deleting", "err"],
  failed: ["Failed", "err"],
};

export function getSiteStatusBadge(site) {
  if (site?.suspended_at) return { label: "Suspended", tone: "err" };
  if (site?.provision_status === "pending_payment")
    return { label: "Awaiting Payment", tone: "warn" };
  if (site?.provision_status === "payment_failed")
    return { label: "Payment Failed", tone: "err" };
  if (site?.provision_status === "provisioning")
    return { label: "Provisioning", tone: "warn" };

  const [label, tone] = STATUS_LABEL_TONE[site?.status] || [];
  return label ? { label, tone } : { label: ucFirst(site?.status) || "Live", tone: "ok" };
}
